import ReactDOM from 'react-dom'
import App from '@components/fund-growth-calculator'

const fn = {
  init: () => {
    document.querySelectorAll('.element-fundgrowthcalculator').forEach((el) => fn.setup(el))
  },

  setup: (el) => {
    const rootNode = el.querySelector('#fund-growth-calculator-root')
    const rates = JSON.parse(rootNode.dataset.rates)

    if (rootNode) {
      ReactDOM.render(<App rates={rates} />, rootNode)
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
